import axios from 'axios';
import {type ActionTree} from 'vuex';
import TopMessageHandler from '../../../../../library/topMessageHandler';

const actions: ActionTree<EnrolmentApplicationState, RootState> = {
    fetchApplication({commit}, applicationId): Promise<any>
    {
        commit('update', {loading: true});

        return new Promise((resolve, reject) =>
        {
            axios.get('/employee/enrolment/application/fetch-application/id/' + applicationId).then(({data: {data}}) =>
            {
                commit('update', {
                    loading: false,
                    applicationData: data,
                });

                resolve(data);
            }).catch(error =>
            {
                TopMessageHandler.error(error.response?.data.message || 'Der Bewerber konnte nicht geladen werden.');
                reject(error);
            });
        });
    },
    updateApplicationStore({commit}, data: object): void
    {
        commit('update', data);
    },
    injectApplicationStore({commit}, data: object): void
    {
        commit('inject', data);
    },
    updateApplicationCallback({commit, state}, callback): void
    {
        commit('callback', callback);
    },
};

export default actions;